module.exports = __webpack_public_path__ + "img/bandeau_personnages.bf47efe8.png";